import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-credit-card',
  templateUrl: './skeleton-credit-card.component.html',
  styleUrls: ['./skeleton-credit-card.component.scss']
})
export class SkeletonCreditCardComponent {

}
